<template>
	<div>
		<v-card elevation="0" :style="'background-color:' + $theme.lightBlue">
			<v-card-title style="font-size: large">
				<v-icon size="20" color="black" style="margin-right: 10px">{{ 'mdi-bell' }}</v-icon>
				알림 관리
			</v-card-title>
			<v-form ref="form" v-model="formValid">
				<v-container fluid>
					<v-row>
						<v-col>
							<v-select
								v-model="item.targetUserType"
								:items="targetUserTypes"
								item-value="code"
								item-text="text"
								label="대상 사용자 유형"
								outlined
								@change="updateTypeName(item.targetUserType, 'targetUserTypeName', targetUserTypes)"
							></v-select>
						</v-col>
						<v-col>
							<v-select
								v-model="item.sendMethodType"
								:items="sendMethodTypes"
								item-value="code"
								item-text="text"
								label="발송 방법"
								outlined
								@change="updateTypeName(item.sendMethodType, 'sendMethodTypeName', sendMethodTypes)"
							></v-select>
						</v-col>
						<!-- <v-col>
							<v-select
								v-model="item.sendPeriodType"
								:items="sendPeriodTypes"
								item-value="code"
								item-text="text"
								label="발송 시기"
								outlined
								@change="updateTypeName(item.sendPeriodType, 'sendPeriodTypeName', sendPeriodTypes)"
							></v-select>
						</v-col>
						<v-col v-if="item.sendPeriodType === sendPeriodTypeCode.appointment.code">
							<v-menu
								ref="menu1"
								v-model="appointmentAtMenu"
								:close-on-content-click="false"
								:return-value.sync="item.appointmentAt"
								transition="scale-transition"
								offset-y
								min-width="290px"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="appointmentAtString" label="예약 발송 일시" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
								</template>
								<v-card>
									<v-date-picker v-model="appointmentAtDate" no-title scrollable>
										<v-spacer></v-spacer>
										<v-time-picker v-model="appointmentAtTime" format="24hr" />
										<v-btn text color="primary" @click="cancelAppointmentAt">Cancel</v-btn>
										<v-btn text color="primary" @click="appointmentAtMenu = false">OK</v-btn>
									</v-date-picker>
								</v-card>
							</v-menu>
						</v-col> -->
					</v-row>
					<v-row v-if="item.sendMethodType !== sendMethodTypeCode.sms.code">
						<v-col>
							<v-text-field v-model="item.title" label="제목" type="text" outlined></v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-textarea name="input-7-1" label="알림 메시지" auto-grow v-model="item.message" outlined />
						</v-col>
					</v-row>
				</v-container>
			</v-form>
			<v-btn rounded :color="$theme.primary" dark elevation="0" class="ma-6" @click="handleClickSendAlert()">
				알림 보내기
			</v-btn>
		</v-card>

		<MessageDialog
			:show="sendMessageDialog"
			:message="confirmMessage"
			:okButton="true"
			okButtonText="발송"
			:cancelButton="true"
			cancelButtonText="취소"
			@onOk="registItem"
			@onCancel="
				$emit('clearItem');
				sendMessageDialog = false;
			"
		/>

		<MessageDialog
			:show="validateMessageDialog"
			:message="validateMessageDialogMessage"
			:okButton="true"
			:cancelButton="false"
			@onOk="validateMessageDialog = false"
		/>
	</div>
</template>

<script>
	import { targetUserTypes, sendMethodTypes, sendPeriodTypes, sendMethodTypeCode } from '@/js/types'; // 절대 경로 사용

	export default {
		name: 'AlertSendForm',
		props: {
			item: {
				default: {},
			},
		},
		data: () => ({
			formValid: false,
			sendMessageDialog: false,
			targetUserTypes, // 외부에서 가져온 타입 배열
			sendMethodTypes, // 외부에서 가져온 타입 배열
			sendMethodTypeCode,
			sendPeriodTypes, // 외부에서 가져온 타입 배열
			confirmMessage: '알림을 발송 하시겠습니까?',
			appointmentAtMenu: false,
			appointmentAtDate: new Date().toISOString().substr(0, 10),
			appointmentAtTime: '00:00',
			previousAppointmentAtDate: null,
			previousAppointmentAtTime: null,
			validateMessageDialog: false,
			validateMessageDialogMessage: '',
		}),
		computed: {
			appointmentAtString() {
				return `${this.appointmentAtDate} ${this.appointmentAtTime}`;
			},
		},
		watch: {
			async show() {
				this.visible = this.show;
				this.$nextTick(() => {
					if (this.$refs.form) {
						this.$refs.form.resetValidation();
					}
				});
			},
			appointmentAtMenu(val) {
				if (val) {
					this.openAppointmentAtMenu();
				}
			},
			item: {
				handler() {
					// item이 업데이트될 때 appointmentAtDate, appointmentAtTime 초기화
					if (this.item.appointmentAt) {
						let AppointmentAt;
						// Firebase Timestamp 형식인지 확인
						if (typeof this.item.appointmentAt.toDate === 'function') {
							AppointmentAt = this.item.appointmentAt.toDate();
						} else {
							// 이미 Date 객체라면
							AppointmentAt = new Date(this.item.appointmentAt);
						}
						// 로컬 날짜와 시간을 설정 (기본 로케일 사용)
						this.appointmentAtDate = AppointmentAt.toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })
							.replace(/. /g, '-')
							.slice(0, -1);
						this.appointmentAtTime = AppointmentAt.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false });
					}
				},
				immediate: true,
			},
		},
		methods: {
			updateTypeName(selectedValue, fieldName, typesArray) {
				const selectedItem = typesArray.find(item => item.code === selectedValue);

				if (selectedItem) {
					this.item[fieldName] = selectedItem.text;
				}
			},
			openAppointmentAtMenu() {
				// v-menu가 열릴 때 현재 값을 임시 저장
				this.previousAppointmentAtDate = this.appointmentAtDate;
				this.previousAppointmentAtTime = this.appointmentAtTime;
			},
			cancelAppointmentAt() {
				// Cancel 버튼이 눌렸을 때 임시 저장된 값으로 되돌리기
				this.appointmentAtDate = this.previousAppointmentAtDate;
				this.appointmentAtTime = this.previousAppointmentAtTime;
				this.appointmentAtMenu = false;
			},
			registItem() {
				this.$refs.form.validate();
				if (this.formValid) {
					this.$emit('registItem', this.item);
					this.sendMessageDialog = false;
				}
			},
			openValidateDialog(validateMessage) {
				this.validateMessageDialogMessage = validateMessage;
				this.validateMessageDialog = true;
				return;
			},
			handleClickSendAlert() {
				if (!this.item.message || this.item.message.trim() === '') {
					return this.openValidateDialog('메시지를 입력해 주세요.');
				}

				if (this.item.sendMethodType !== sendMethodTypeCode.sms.code && (!this.item.title || this.item.title.trim() === '')) {
					return this.openValidateDialog('제목을 입력해 주세요.');
				}

				this.confirmMessage = `[${this.item.targetUserTypeName}] 사용자에게 [${this.item.sendMethodTypeName}] 알림을 발송하시겠습니까?`;
				this.sendMessageDialog = true;
			},
		},
	};
</script>

<style scoped></style>
